<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết đơn đặt hàng</h1>
      <div class="btn-group float-right">
        <button class="btn btn-secondary" @click="cancel">
          <i class="bx bx-arrow-back"></i>
          Quay lại
        </button>
        <button class="btn btn-primary" v-if="detail?.status === 'NEW' && dataUser.agentId === detail.userCreator?.id"
          @click="update">
          Sửa
        </button>
        <button
          v-if="dataUser && dataUser.permissionCodes.includes('CNPS_DEVICE_PURCHASE_ORDER_AGENT_APPROVE') && detail?.status === 'NEW'"
          class="btn btn-primary" @click="comfirm">
          Xác nhận
        </button>
        <button
          v-if="dataUser && dataUser.permissionCodes.includes('CNPS_DEVICE_PURCHASE_ORDER_AGENT_APPROVE') && detail?.status === 'NEW'"
          class="btn btn-danger" @click="reject">
          Từ chối
        </button>
        <button v-if="detail.status === 'NEW' && dataUser.agentId === detail.userCreator?.id" class="btn btn-danger"
          @click="cancelTransfer">
          Huỷ phiếu
        </button>
      </div>
    </div>
    <div class="p-10 m-1 b-t-1-869fb229">
      <div class="card-body form-row">
        <div class="col-12">
          <div class="row">
            <!-- Thông tin đơn -->
            <div class="col-md-6 px-2">
              <Card style="box-shadow: none; border: 1px solid #d7d7d7; margin-bottom: 20px" title="Thông tin đơn">
                <Content title="Mã đơn" :content="detail.orderCode || ''"></Content>
                <Content title="Mã đơn" :content="detail.orderCode || ''" />
                <Content title="Đơn vị nhận hàng" :content="detail.agentName || ''" />
                <Content title="Địa chỉ nhận hàng" :content="detail.agentAddress || ''" />
                <Content title="Người tạo" :content="detail.userCreator?.name || ''" />
                <Content title="Ngày tạo" :content="formatDate(detail.createdTime)" />
                <Content title="Ngày nhận dự kiến" :content="formatDate(detail.estimatedTime)" />
                <Content title="Ghi chú" :content="detail.note || ''" />
                <Content title="Trạng thái">
                  <span class="badge " :class="getStatusClass(detail.status)">
                    {{ transformStatus(detail.status) }}
                  </span>
                </Content>

              </Card>
              <!-- Bảng danh sách thiết bị -->
              <Card style="box-shadow: none; border: 1px solid #d7d7d7; margin-bottom: 20px" title="Thiết bị">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>Loại thiết bị</th>
                      <th>Số lượng</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in detail.orderDetail" :key="index">
                      <td>{{ item.categoryName }}</td>
                      <td>{{ item.quantity }}</td>
                    </tr>
                  </tbody>
                </table>
              </Card>
            </div>

            <!-- Lịch sử -->
            <div class="col-md-6 px-2">
              <Card style="box-shadow: none; border: 1px solid #d7d7d7; margin-bottom: 20px" title="Lịch sử">
                <div class="timeline2 mt-2">
                  <!-- Cập nhật đơn đặt hàng -->
                  <div class="timeline-item" v-for="(item, index) in detail.orderHistory || []" :key="index">
                    <div class="timeline-date">{{ formatDate(item.createdTime) }}</div>
                    <div class="timeline-content">
                      <div class="timeline-title">{{ item.description }}</div>
                      <div v-if="item.reasonReject" class="timeline-description">Lý do: {{ item.reasonReject }}</div>
                    </div>
                  </div>
                </div>
              </Card>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="notiModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">
                    Thông báo
                  </h5>
                  <button type="button" class="close" data-dismiss="modal" @click="notiModal = false"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body text-center">
                  <img :src="iconNoti" alt="icon-successs" />
                  <h2 class="f18 py-3">{{ msgNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-light" @click="notiModal = false" data-dismiss="modal">
                    Đóng
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay>
  </div>
</template>

<script>
import Config from '@/thirdParty/config'
import { DeviceService } from '@/services/device.service'
import Card from '@/components/common/Card.vue'
import Content from '@/components/common/Content.vue'

export default {
  components: { Card, Content },
  data () {
    return {
      showLoading: false,
      dataUser: JSON.parse(localStorage.getItem('userData')) ?? {},
      id: this.$route.params.id,
      optionStatus: [
        ...Config.satusOderForm
      ],
      detail: {},
      notiModal: false,
      msgNoti: ''
    }
  },

  created () {
    this.fetchData()
  },

  methods: {
    showSuccess (message) {
      this.notiModal = true
      this.iconNoti = require('@/assets/img/noti-success2.svg')
      this.msgNoti = message
    },
    showErr (message) {
      this.notiModal = true
      this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
      this.msgNoti = message
    },
    getStatusName (status) {
      const found = this.optionStatus.find(option => option.id === status)
      return found ? found.text : status
    },
    formatDate (timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp)
      return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`
    },

    transformStatus (status) {
      const found = this.optionStatus.find(option => option.id === status)
      return found ? found.text : status
    },

    getStatusClass (status) {
      const found = this.optionStatus.find(option => option.id === status)
      return found ? found.bgColor : ''
    },

    cancel () {
      this.$router.push('/order-form')
    },

    update () {
      this.$router.push(`/order-form-edit/${this.id}`)
    },

    comfirm () {
      this.$bvModal
        .msgBoxConfirm('Bạn có chắc chắn muốn xác nhận đơn đặt hàng này?', {
          title: 'Xác nhận đơn đặt hàng',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ'
        })
        .then(async value => {
          if (value) {
            this.showLoading = true
            try {
              const res = await DeviceService.ComfirmOrder({
                id: this.id
              })

              if (res.code === 1000) {
                this.showSuccess(`Xác nhận đơn đặt hàng ${this.detail.orderCode} thành công`)
                this.fetchData()
              } else {
                this.showErr(res.message)
              }
            } catch (error) {
              this.showErr(error.message || 'Đã xảy ra lỗi khi xử lý đơn hàng')
            } finally {
              this.showLoading = false
            }
          }
        })
        .catch(() => { })
    },
    cancelTransfer () {
      this.$bvModal
        .msgBoxConfirm('Bạn có chắc chắn muốn huỷ đơn đặt hàng này?', {
          title: 'Xác nhận huỷ đơn đặt hàng',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ'
        })
        .then(async value => {
          if (value) {
            this.showLoading = true
            try {
              const res = await DeviceService.CancelOrder({
                id: this.id
              })

              if (res.code === 1000) {
                this.showSuccess(`Xác nhận huỷ đơn đặt hàng ${this.detail?.orderCode} thành công`)
                this.fetchData()
              } else {
                this.showErr(res.message)
              }
            } catch (error) {
              this.showErr(error.message || 'Đã xảy ra lỗi khi xử lý đơn hàng')
            } finally {
              this.showLoading = false
            }
          }
        })
        .catch(() => { })
    },

    reject () {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('textarea', { ref: 'rejectValue', class: 'form-control f12', placeholder: 'Nhập lý do từ chối' })
      ])

      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lý do từ chối',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          okDisabled: false
        })
        .then(async value => {
          if (value) {
            this.showLoading = true
            try {
              const res = await DeviceService.RejectOrder({
                id: this.id,
                reasonReject: this.$refs.rejectValue.value
              })

              if (res.code === 1000 || res.success) {
                this.showSuccess(`Từ chối đơn đặt hàng ${this.detail.orderCode} thành công`)
                this.fetchData()
              } else {
                this.showErr(res.message)
              }
            } catch (error) {
              this.showErr(error.message || 'Đã xảy ra lỗi khi xử lý đơn hàng')
            } finally {
              this.showLoading = false
            }
          }
        })
        .catch(() => {
          this.showLoading = false
        })
    },

    async fetchData () {
      try {
        this.showLoading = true
        const data = await DeviceService.DetailOrderFormPartner({
          id: this.id
        })

        if (data.success || data.code === 1000) {
          this.detail = data.data
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.showLoading = false
      }
    }
  }
}
</script>

<style scoped>
.breadcrumb-area {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-group .btn {
  margin-left: 5px;
}

.timeline {
  position: relative;
  margin: 0;
  padding: 0;
}

.timeline-item {
  position: relative;
  padding-bottom: 20px;
  padding-left: 15px;
}

.timeline-date {
  position: absolute;
  right: 5px;
  top: 8px;
  color: #5381e5;
  font-size: 0.85rem;
  z-index: 10;
}

.timeline-content {
  padding: 10px 15px;
  background-color: #f8f9fa;
  border-radius: 5px;
  margin-left: 10px;
  position: relative;
}

.timeline-content:before {
  content: '';
  position: absolute;
  top: 12px;
  left: -16px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #007bff;
  border: 2px solid #fff;
}

.timeline-title {
  font-weight: 500;
  margin-bottom: 5px;
  font-size: 14px;
  font-family: sans-serif;
}

.timeline-description {
  font-size: 0.75rem;
  color: #666;
}

.card-title {
  font-weight: bold;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 15px;
  margin-left: 5px;
}

.table th {
  background-color: #f8f9fa;
}

.form-control-plaintext {
  font-size: 13px;
}
</style>
